import React, { useState } from "react";
import "./allBlogs.scss";
import blogO from "../../assets/blog/blogO.png";
import blogbg from "../../assets/blog/successful-medical-team 2.png";
import { RiSearch2Line } from "react-icons/ri";
import { BlogCategory } from "../../constants/Blog";
import {
  BsFacebook,
  BsInstagram,
  BsLinkedin,
  BsTwitter,
  BsArrowRight,
} from "react-icons/bs";
import Button from "../Common/Button/Button";
import SubscribeNews from "./SubscribeNews/SubscribeNews";

const AllBlogs = () => {
  const [selectIndex, setSelectIndex] = useState("Popular tags");

  return (
    <>
      <section id="all-blogs-wrapper">
        <div className="blogs-banner">
          <p>
            <img src={blogO} alt="blog" />
            BL <span>O</span> G
          </p>
          <div className="search-bar">
            <RiSearch2Line className="icon" />
            <input type="search" name="" id="" />
            <button>Search</button>
          </div>
          <div className="blog-tab">
            {BlogCategory?.map((item) => {
              const isActive = item.name === selectIndex;
              return (
                <>
                  <button
                    className={isActive ? "active" : ""}
                    onClick={() => setSelectIndex(item?.name)}
                  >
                    {item?.name}
                  </button>
                </>
              );
            })}
          </div>
        </div>
        <div className="row gap">
          <div className="col-lg-8">
            <div className="row ">
              <div className="col-md-6 blogs-list">
                <div className="feature-image">
                  <img src={blogbg} alt="" />
                </div>
                <p className="category">Covid-19</p>
                <h2 className="blog-title">
                  Protect our health from Covid-19 disease{" "}
                  <span>1 Day ago</span>
                </h2>

                <p className="blog-discription">
                  {" "}
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna
                  aliqua....
                </p>
                <a href="" className="read-more">
                  Read More
                </a>
              </div>
              <div className="col-md-6 blogs-list">
                <div className="feature-image">
                  <img src={blogbg} alt="" />
                </div>
                <p className="category">Covid-19</p>
                <h2 className="blog-title">
                  Protect our health from Covid-19 disease{" "}
                  <span>1 Day ago</span>
                </h2>

                <p className="blog-discription">
                  {" "}
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna
                  aliqua....
                </p>
                <a href="" className="read-more">
                  Read More
                </a>
              </div>
              <div className="col-md-6 blogs-list">
                <div className="feature-image">
                  <img src={blogbg} alt="" />
                </div>
                <p className="category">Covid-19</p>
                <h2 className="blog-title">
                  Protect our health from Covid-19 disease{" "}
                  <span>1 Day ago</span>
                </h2>

                <p className="blog-discription">
                  {" "}
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna
                  aliqua....
                </p>
                <a href="" className="read-more">
                  Read More
                </a>
              </div>
              <div className="col-md-6 blogs-list">
                <div className="feature-image">
                  <img src={blogbg} alt="" />
                </div>
                <p className="category">Covid-19</p>
                <h2 className="blog-title">
                  Protect our health from Covid-19 disease{" "}
                  <span>1 Day ago</span>
                </h2>

                <p className="blog-discription">
                  {" "}
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna
                  aliqua....
                </p>
                <a href="" className="read-more">
                  Read More
                </a>
              </div>
            </div>
            <div className="load-more-wrapper">
              <Button id="arrow-wrapper-right">Load More</Button>
            </div>
            <div className="subscribe">
                <SubscribeNews/>
            </div>
          </div>

          <div className="col-lg-4 right-wrapper">
            <div className="about-us">
              <h3 className="title">About us</h3>
              <hr />
              <p className="description">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua....
              </p>
              <p className="follow">Follow For More</p>
              <div className="icons">
                <div className="follow-icons">
                  <div className="icon">
                    <BsFacebook />
                  </div>
                  <div className="icon">
                    <BsInstagram />
                  </div>
                  <div className="icon">
                    <BsLinkedin />
                  </div>
                  <div className="icon">
                    <BsTwitter />
                  </div>
                </div>
              </div>
            </div>
            <div className="popular-post">
              <h3 className="post-heading">Popular Post</h3>
              <hr />
              <div className="row popular-blog">
                <div className="col-4">
                  <img src={blogbg} alt="" />
                </div>
                <div className="col-8">
                  <div className="catory-date">
                    <p className="category">Covid-19</p>
                    <span>! Day ago</span>
                  </div>
                  <h3 className="title">
                    Various versions have evolved over the years
                  </h3>
                  <div className="read-more">
                    <a href="" className="read">
                      Read More
                    </a>
                    <BsArrowRight />
                  </div>
                </div>
              </div>
              <div className="row popular-blog">
                <div className="col-4">
                  <img src={blogbg} alt="" />
                </div>
                <div className="col-8">
                  <div className="catory-date">
                    <p className="category">Covid-19</p>
                    <span>! Day ago</span>
                  </div>
                  <h3 className="title">
                    Various versions have evolved over the years
                  </h3>
                  <div className="read-more">
                    <a href="" className="read">
                      Read More
                    </a>
                    <BsArrowRight />
                  </div>
                </div>
              </div>
              <div className="row popular-blog">
                <div className="col-4">
                  <img src={blogbg} alt="" />
                </div>
                <div className="col-8">
                  <div className="catory-date">
                    <p className="category">Covid-19</p>
                    <span>! Day ago</span>
                  </div>
                  <h3 className="title">
                    Various versions have evolved over the years
                  </h3>
                  <div className="read-more">
                    <a href="" className="read">
                      Read More
                    </a>
                    <BsArrowRight />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AllBlogs;
